import ItemsList from "../components/ItemsList";
import '../styles/ItemList.css'

function Index() {
  return (
    <div className="Index">
      <ItemsList />
    </div>
  );
}

export default Index;